// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"b031debd","453":"a916b8e3","551":"fece4e12"}[chunkId] + ".chunk.js";
};